export { ForgottenPasswordTemplate } from './ForgottenPasswordTemplate';
export type {
  ForgottenPasswordTemplateLabels,
  ForgottenPasswordTemplateProps,
} from './ForgottenPasswordTemplate.types';
